import DOMPurify from 'dompurify';
import { stripDraftingHighlights } from './draftingWorkflow/insertion';

const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'b',
  'i',
  'u',
  'ul',
  'ol',
  'li',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
  'span',
  'div',
  'blockquote',
  'hr',
];

export function sanitizeAiHtml(html: string): string {
  if (!html) return '';
  const sanitized = DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ['class', 'style', 'colspan', 'rowspan'],
  });
  return stripDraftingHighlights(sanitized);
}
